import React from 'react'

const AccountPage = () => {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold mb-4">Account Page</h1>
      <p>This is a placeholder for the Account page.</p>
    </div>
  )
}

export default AccountPage